import { AfterViewInit, ViewChild, Component, OnInit, Renderer2, ElementRef, Input  } from '@angular/core';
import { environment } from "src/environments/environment";
import { OAuthService } from "angular-oauth2-oidc";
import { HttpClient } from "@angular/common/http";


@Component({
  selector: 'app-chatbot-widget',
  templateUrl: './chatbot-widget.component.html',
  styleUrls: ['./chatbot-widget.component.scss']
})
export class ChatbotWidgetComponent implements OnInit, AfterViewInit {

  env = environment;
  @ViewChild('chatbotWidget', { static: false }) chatbot!: ElementRef;
  @Input() appID: number;

  userType: string = 'Parent';    
  language: string = 'en';
  chatbotScriptUrl: string = this.env.chatbotScriptURL;
  chatbotCheckAccessUrl: string = `${this.env.chatbotAPIBaseURL}/chat/verifyaccess}`;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private oAuthService: OAuthService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {

    console.log('Chatbot oninit');      
    this.loadChatScript();

  }

  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   this.initializeChatbot();
    // },0 );
    
  }

  verifyAccess(): boolean {

    this.http.post(this.chatbotCheckAccessUrl, {}).subscribe({
      next: (response: any) => {
        console.log("API Response:", response);

        // Extract UniqueToken from response
        var uniqueToken = response?.UniqueToken || "";

        // if (uniqueToken) {
        //   console.log("UniqueToken received:", uniqueToken);
        //   this.setVoiceSessionID(authToken, uniqueToken);
        // } else {
        //   console.warn("No UniqueToken in response");
        //   this.showChatbot = true; // Show chatbot even if no unique token
        // }
      },
      error: (error) => {
        console.error("API Error:", error);
        // this.showChatbot = false; // Hide chatbot if API fails
        // this.showError = true;
      },
    });

    return false;

  }


  loadChatScript() {

    if (this.env.enableChatbot == false) {
      return;
    }

    if (this.verifyAccess() == false){
      return;
    }

    if (!document.querySelector(`script[src="${this.chatbotScriptUrl}"]`)) {
      const script = this.renderer.createElement('script');
      script.src = this.chatbotScriptUrl;      
      script.onload = () => {
        this.initializeChatbot(); // Ensure script is loaded before calling methods
      };
      document.body.appendChild(script);
    }
    else {
      this.initializeChatbot();
    }
  }

  

  initializeChatbot() {

    const chatbotElement = this.chatbot.nativeElement as any;
    
    if (chatbotElement) {
      chatbotElement.setAuthToken(this.oAuthService.authorizationHeader());
      chatbotElement.setAppID(this.appID);
      chatbotElement.setUserType(this.userType);      
      chatbotElement.setDeviceType(window.navigator.userAgent);

      console.log('appid ' + this.appID);      
      console.log('Chatbot initialized');      
    } else {
      console.error('Chatbot widget error');
    }
  }
}
